<kw-wrapper>
    <div class="layout-layer">
        <div class="h5">Shopping Cart</div>
        <div class="checkout-options">
            <div class="cart-actions">
                <nb-actions size="small">
                    <nb-action icon="trash-outline" pack="eva" title="Emty Cart"></nb-action>
                    <nb-action>Continue Shopping</nb-action>
                </nb-actions>
            </div>
            <div class="checkout-actions">
                <nb-actions size="tiny">
                    <nb-action>Remove Selected</nb-action>
                    <nb-action>
                        <button nbButton status="primary" size="tiny">Checkout</button>
                    </nb-action>
                </nb-actions>
            </div>
        </div>
        
        <angular2-smart-table [settings]="settings" [source]="source"></angular2-smart-table>
        <div>
            <angular2-smart-table [settings]="settings2" [source]="source2"></angular2-smart-table>
        </div>
    </div>
</kw-wrapper>
